import { ProductHealthInsuranceDto, UpdateProductHealthInsuranceDto } from "../client/types.gen";
import { ProductHealthInsurance } from "../dtos/ProductHealthInsurance";
import { BaseEndpoint } from "./BaseEndpoint";
import { Page } from "./domain";

export class ProductHealthInsuranceEndpoint extends BaseEndpoint("product-health-insurance") {
  create(body: unknown): Promise<ProductHealthInsuranceDto> {
    return this.request("", {
      body,
      method: "POST",
    });
  }

  async update(id: string, body: UpdateProductHealthInsuranceDto): Promise<ProductHealthInsurance> {
    return this.request(`${id}`, {
      body,
      method: "PATCH",
    });
  }

  delete(id: string): Promise<void> {
    return this.request(`${id}`, {
      method: "DELETE",
    });
  }

  associate(productHealthInsuranceId: string, productId?: string): Promise<ProductHealthInsurance> {
    return this.request(`associate-product/${productHealthInsuranceId}`, {
      body: {
        productId,
        productHealthInsuranceId,
      },
      method: "PATCH",
    });
  }

  getAll(page: number, size?: number): Promise<Page<ProductHealthInsurance>> {
    return this.request("all", {
      query: {
        page,
        size,
      },
    });
  }

  findAllWithAssociatedProduct(
    page: number,
    size: number,
    search?: string,
    productId?: boolean,
  ): Promise<Page<ProductHealthInsurance>> {
    return this.request("with-associated-product", {
      query: {
        page,
        size,
        search,
        productId,
      },
    });
  }
}
